/**
 * Fonctions utilitaires
 */
const showLoader = (cartItems, loader) => {
  cartItems.classList.add('pointer-events-none');
  if(loader) loader.hidden = false;
  document.activeElement.blur();
};

const hideLoader = (cartItems, loader) => {
  cartItems.classList.remove('pointer-events-none');
  if(loader) loader.hidden = true;
};

const clearErrors = (lineErrorsId) => {
  document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach(el => {
    el.innerHTML = '';
    el.hidden = true;
  });
};

const fetchCart = async() => {
  const response = await fetch('/cart.js');
  return response.json();
};

const updateCart = async(updates) => {
  await fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({updates}),
  });
};

const fetchStorefrontVariants = async(variantIds) => {
  const globalIds = variantIds.map(id => `gid://shopify/ProductVariant/${id}`);
  const encodedIds = globalIds.map(id => btoa(id));
  const query = `
    query($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          availableForSale
          quantityAvailable
        }
      }
    }`;
  const variables = {ids: encodedIds};

  const response = await fetch(SHOPIFY_GRAPHQL_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({query, variables}),
  });

  const data = await response.json();
  return data.data.nodes;
};

/**
 * Fonction pour mettre à jour la note du panier
 */
const updateCartNote = async(bundleId) => {
  try{
    const cart = await fetchCart();
    let note = cart.note || '';

    const regex = new RegExp(`START\\s+${bundleId}[\\s\\S]*?END\\s+${bundleId}\\s*`, 'g');
    const updatedNote = note.replace(regex, '').trim();
    const cleanedNote = updatedNote.replace(/\n{2,}/g, '\n');

    await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({note: cleanedNote}),
    });

  }catch(error){
    console.error('Erreur lors de la mise à jour de la note du panier:', error);
  }
};

/**
 * Fonction équivalente à App.sendDebugLog()
 * @param {string} message - Message personnalisé à transmettre
 * @param {string} [errorMessage] - Message d’erreur éventuel
 */
async function sendDebugLog(message, errorMessage = ''){
  try{
    //Récupération des données essentielles côté client
    const userAgent = navigator.userAgent || 'inconnu';
    const currentUrl = window.location.href;

    //Récupération du JSON du panier Shopify
    const cartResponse = await fetch('/cart.js');
    const cartData = cartResponse.ok ? await cartResponse.json() : null;

    //Préparation des données à envoyer
    const logData = {
      message,
      errorMessage,
      userAgent,
      currentUrl,
      cartData,
    };

    // Envoi des données
    fetch('https://test.adventury.net/lumeo/log-198941b3-9896-4d61-98d4.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(logData),
    }).catch((err) => {
      console.warn('Impossible d’envoyer les logs :', err);
    });
  }catch(err){
    console.warn('Erreur lors de la préparation des logs :', err);
  }
}


/**
 * Vérifie la présence de "Abat-jour" dans le titre de .cart-item__title
 * et déclenche sendDebugLog si trouvé.
 */
function checkAbatJourInCart(){
  const cartItemTitles = document.querySelectorAll('.cart-item__title');
  let hasAbatJourSeul = false;
  cartItemTitles.forEach((titleElement) => {
    if(titleElement.textContent.includes('Abat-jour')){
      hasAbatJourSeul = true;
    }
  });

  if(hasAbatJourSeul){
    sendDebugLog('KO', 'Détection d’un élément "Abat-jour" dans le panier');
  }
}


/**
 * DELETE Handler
 */
document.addEventListener('click', async(event) => {
  if(event.target.classList.contains('remove-virtual-bundle__button')){
    const button = event.target;
    const bundleId = button.getAttribute('data-index');
    const cartItems = button.closest('cart-items');
    const loader = document.querySelector(`#cart-item-${bundleId} .cart-item__loader`);
    const lineErrorsId = `line-item-error-${bundleId}`;
    const lineErrors = document.getElementById(lineErrorsId);

    showLoader(cartItems, loader);
    clearErrors(lineErrorsId);

    try{
      const cart = await fetchCart();
      const itemsToRemove = cart.items.filter(item => item.properties?._virtual_bundle_id === bundleId);

     if(itemsToRemove.length > 0){
       const updates = itemsToRemove.reduce((acc, item) => ({...acc, [item.key]: 0}), {});
       await updateCart(updates);
     }

      //Mettre à jour la note du panier en supprimant le bloc correspondant
      await updateCartNote(bundleId);

      hideLoader(cartItems, loader);
      cartItems.refresh();
      checkAbatJourInCart();
      document.querySelectorAll('.cart-item__loader').forEach(loader => loader.hidden = true);

    }catch(error){
      console.error('Erreur lors de la suppression de l\'élément du panier:', error);
      hideLoader(cartItems, loader);
      lineErrors.textContent = error.message || 'Une erreur est survenue lors de la mise à jour du panier.';
      lineErrors.hidden = false;
    }
  }
});

/**
 * UPDATE Handler
 */
document.addEventListener('click', async(event) => {
  if(event.target.classList.contains('modify-virtual-bundle__button')){
    const button = event.target;
    const action = button.getAttribute('name');
    const quantityInput = button.closest('.qty-input').querySelector('.qty-input__input');
    const bundleId = quantityInput.id.replace('quantity-', '');
    const cartItems = button.closest('cart-items');
    const loader = document.querySelector(`#cart-item-${bundleId} .cart-item__loader`);
    const lineErrorsId = `line-item-error-${bundleId}`;
    const lineErrors = document.getElementById(lineErrorsId);
    let currentQuantity = parseInt(quantityInput.value, 10) || 1;

    showLoader(cartItems, loader);
    clearErrors(lineErrorsId);

    try{
      const cart = await fetchCart();
      const itemsInBundle = cart.items.filter(item => item.properties?._virtual_bundle_id === bundleId);

      if(!itemsInBundle.length) throw new Error('Luminaire non trouvé dans le panier.');

      if(action === 'plus'){
        const variantIds = itemsInBundle.map(item => item.variant_id);
        const variantsData = await fetchStorefrontVariants(variantIds);

        const sufficientStock = variantsData.every((variant, index) =>
            variant?.availableForSale && variant.quantityAvailable >= itemsInBundle[index].quantity,
        );

        if(!sufficientStock) throw new Error('Vous ne pouvez plus ajouter ce luminaire au panier.');

        //Création du nouveau bundle
        /*
        const newBundleId = `bundle_${Date.now()}`;
        const itemsToAdd = itemsInBundle.map(item => ({
          id: item.variant_id,
          quantity: item.quantity,
          properties: {
            ...item.properties,
            _virtual_bundle_id: newBundleId,
            _display_bundle_number: '1',
          },
        }));

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: itemsToAdd}),
        });

        if(!addResponse.ok) throw new Error('Vous ne pouvez plus ajouter ce luminaire au panier.');

        //quantityInput.value = currentQuantity + 1;
        */

        hideLoader(cartItems, loader);
        cartItems.refresh();
        checkAbatJourInCart();

      }else if(action === 'minus'){
        if(currentQuantity > 1){
          const otherBundles = cart.items.filter(item =>
              item.properties &&
              item.properties._virtual_bundle_id !== bundleId &&
              item.properties._display_cart_bundle_prix_par_bundle === itemsInBundle[0].properties._display_cart_bundle_prix_par_bundle &&
              item.properties._display_cart_bundle_prix_total === itemsInBundle[0].properties._display_cart_bundle_prix_total,
          );

          if(otherBundles.length > 0){
            const bundleToRemoveId = otherBundles[0].properties._virtual_bundle_id;
            const itemsToRemove = cart.items.filter(item => item.properties?._virtual_bundle_id === bundleToRemoveId);

            const updates = itemsToRemove.reduce((acc, item) => ({...acc, [item.key]: 0}), {});
            await updateCart(updates);

            //quantityInput.value = currentQuantity - 1;
            hideLoader(cartItems, loader);
            cartItems.refresh();
            checkAbatJourInCart();

          }else{
            throw new Error('Aucun autre luminaire à supprimer.');
          }
        }else{
          hideLoader(cartItems, loader);
          return;
        }
      }
    }catch(error){
      console.error('Erreur lors de la mise à jour du panier:', error);
      hideLoader(cartItems, loader);
      lineErrors.textContent = error.message || 'Une erreur est survenue lors de la mise à jour du panier.';
      lineErrors.hidden = false;
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  checkAbatJourInCart();

  document.addEventListener('click', (event) => {
    if(event.target.classList.contains('afficher-detail-luminaire')){
      event.preventDefault();
      const button = event.target;
      const bundleId = button.getAttribute('data-id');
      const detailElement = document.querySelector(`.detail-luminaire[data-id="${bundleId}"]`);
      if(detailElement.style.display !== 'none'){
        detailElement.style.display = 'none';
      }else{
        detailElement.style.display = 'block';
      }
    }
  });
});
